/**
 * Created by Mikhail Menshenin on 23.01.2025
 */

cleverapps.User.prototype.initializeNewPlayerGold = function () {
    this.gold = 10500;
};
